import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { SearchFiltersDropdown } from '../../components/search-filters-dropdown/search-filters-dropdown'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { rangeMax, rangeMin } from './static-props'
import { ariaLabel } from '../../utils/form-utilities'

export const GrossTrailerWeightMin = withFacetContext(
    FacetName.gross_trailer_weight,
    withFilterContext(FilterName.min_gross_trailer_weight, SearchFiltersDropdown, {
        ...rangeMin,
        ariaLabel: ariaLabel.gtw.min,
    })
)
export const GrossTrailerWeightMax = withFacetContext(
    FacetName.gross_trailer_weight,
    withFilterContext(FilterName.max_gross_trailer_weight, SearchFiltersDropdown, {
        ...rangeMax,
        ariaLabel: ariaLabel.gtw.max,
    })
)
